import { Marker, GeoJSON, Polyline } from "react-leaflet"
import { GeoJsonFeature } from "../../../services/OgcService/models/GeoJsonFeature"
import { SituationProperties } from "../../../services/OgcService/models/SituationFeatureCollection"
import * as L from "leaflet";
import { GeoJsonGeometryType } from "../../../services/RuteplanAPI/models/GeoJsonGeometryType";
import { GeoJsonLineWithHalo } from "../GeoJsonLineWithHalo";

export interface ITrafficMessageLineMarkerProps {
    trafficMessage: GeoJsonFeature<SituationProperties>
    icon: L.DivIcon;
    displayPolyline: boolean;
    onTrafficMessageClicked: (feature: GeoJsonFeature<SituationProperties>) => void;
}

export function TrafficMessageLineMarker(trafficeMessageMarkerProps: ITrafficMessageLineMarkerProps) {
    const {trafficMessage, icon, displayPolyline, onTrafficMessageClicked} = trafficeMessageMarkerProps;

    if (trafficMessage && trafficMessage.geometry.type === GeoJsonGeometryType.LINE_STRING) {
        const coordinates = GetMedianCoordinate(trafficMessage.geometry.coordinates)
        return (
            <>
                <Marker
                    key={trafficMessage.properties._id}
                    eventHandlers={{ click: (e) => { onTrafficMessageClicked(trafficMessage) } }}
                    icon={icon}
                    position={[coordinates[1], coordinates[0]]}>
                </Marker>
                
                {displayPolyline && 
                    <GeoJsonLineWithHalo key={trafficMessage.properties._id+'_LINE'} data={trafficMessage} color="#ff0000" haloColor="#000000" weight={2} onEachFeature={(_feature, layer) => {
                        layer.on('click', () => {
                            onTrafficMessageClicked(trafficMessage);
                          })
                    }} />
                }
            
            </>
        )
    }
    return null;
}

function GetLineCoordinates(coordinates : number[][]){
    return coordinates.map((coor) => {
        return L.latLng(coor[1], coor[0])
    })
} 

function GetMedianCoordinate(coordinates : number[][]){
    const median = Math.round(coordinates.length / 2);
    return coordinates[median];
} 